(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4459],{

/***/ 46412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79373);
/* harmony import */ var _styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3__);




const ErrorComponent = (props)=>{
    const { serverError  } = props;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        function randomNum() {
            "use strict";
            return Math.floor(Math.random() * 9) + 1;
        }
        let increaseTimer = 0;
        const time = 30, selector3 = document.querySelector(".thirdDigit"), selector2 = document.querySelector(".secondDigit"), selector1 = document.querySelector(".firstDigit");
        const loop3 = setInterval(function() {
            "use strict";
            if (increaseTimer > 40) {
                clearInterval(loop3);
                if (selector3) selector3.textContent = serverError ? "5" : "4";
            } else {
                if (selector3) selector3.textContent = randomNum().toString();
                increaseTimer++;
            }
        }, time);
        const loop2 = setInterval(function() {
            "use strict";
            if (increaseTimer > 80) {
                clearInterval(loop2);
                if (selector2) selector2.textContent = "0";
            } else {
                if (selector2) selector2.textContent = randomNum().toString();
                increaseTimer++;
            }
        }, time);
        const loop1 = setInterval(function() {
            "use strict";
            if (increaseTimer > 100) {
                clearInterval(loop1);
                if (selector1) selector1.textContent = serverError ? "0" : "4";
            } else {
                if (selector1) selector1.textContent = randomNum().toString();
                increaseTimer++;
            }
        }, time);
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        id: "error-component",
        className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().main),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().error),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "col-xs-12 text-center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().containerError404),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().clip),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().shadow),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: `${(_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().digit)} thirdDigit`
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().clip),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().shadow),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: `${(_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().digit)} secondDigit`
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().clip),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().shadow),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: `${(_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().digit)} firstDigit`
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().msg),
                                    children: [
                                        "OH!",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().triangle)
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "h1",
                            children: "OOPS, SORRY WE CAN'T FIND THAT PAGE!"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            children: "Either something went wrong or the page doesn't exist anymore."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().btndiv),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                href: "/",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: `${(_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().btnPrimary)}`,
                                    children: "Back to home"
                                })
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ErrorComponent);


/***/ }),

/***/ 47046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ MetaTagsComp; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59830);





const MetaTagsComp = (props)=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const currentUrl = "https://staging.studies-overseas.com" + (router.asPath || "");
    const { metaTitle , metaDescription , src , keywords , robotsMeta , ogimage , twitterimage , isCustomSchema , schemaJson , jotforms , canonicalUrl , isBlogPage  } = props;
    const structuredJSON = isCustomSchema && schemaJson ? schemaJson : _utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .defaultSchema */ .R4;
    const removeQueryParameters = (url)=>{
        const currentUrl = url;
        const queryIndex = currentUrl.indexOf("?");
        return queryIndex !== -1 ? currentUrl.slice(0, queryIndex) : currentUrl;
    };
    const cleanCanonicalUrl = canonicalUrl ? removeQueryParameters(canonicalUrl) : removeQueryParameters(currentUrl);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                    children: metaTitle
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "description",
                    content: metaDescription
                }),
                keywords && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "keywords",
                    content: keywords
                }),
                robotsMeta && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "robots",
                    content: robotsMeta
                }),
                metaTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:title",
                    content: metaTitle
                }),
                metaDescription && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:description",
                    content: metaDescription
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:url",
                    content: isBlogPage ? cleanCanonicalUrl : currentUrl
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:type",
                    content: "Organization"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:image",
                    content: ogimage || "https://www.studies-overseas.com/kc_schema_logo.png"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:site_name",
                    content: isBlogPage ? cleanCanonicalUrl : currentUrl
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                    rel: "canonical",
                    href: cleanCanonicalUrl || canonicalUrl
                }),
                src && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    src: src
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:card",
                    content: "summary_large_image"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:site",
                    content: "@KCOverseasEdu"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:creator",
                    content: "@KCOverseasEdu"
                }),
                metaTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:title",
                    content: metaTitle
                }),
                metaDescription && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:description",
                    content: metaDescription
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:image",
                    content: twitterimage || "https://www.studies-overseas.com/kc_schema_logo.png"
                }),
                structuredJSON && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    className: "structured-data-list",
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(structuredJSON)
                    }
                })
            ]
        })
    });
};


/***/ }),

/***/ 74050:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21174);
/* harmony import */ var _styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34051);
/* harmony import */ var react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31555);
/* harmony import */ var _CustomImage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45992);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _hooks_useZipmeLink__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98196);
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32866);










const EduFairFooterCommon = ({ data , jotformId , externalLink  })=>{
    const { zipmeLink , generateLink  } = (0,_hooks_useZipmeLink__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        id: "edu-fair-footer",
        className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_6___default().footer),
        style: {
            backgroundColor: data?.sectionTopBgColor || "#fff"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_6___default().content),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            id: "edu-fairlog",
                            className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_6___default().footerLogo),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                src: "/images/educationfair/kc_logo.svg",
                                width: 200,
                                height: 58,
                                className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_6___default().studImg),
                                alt: "kclogo"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        children: data?.offices?.length > 0 && data?.offices.map((office, index)=>{
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                xl: 6,
                                lg: 6,
                                md: 6,
                                sm: 12,
                                xs: 12,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_6___default().address),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                            children: office?.officeName
                                        }),
                                        office?.address && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                    children: [
                                                        office.addressLabel || "Address",
                                                        " : "
                                                    ]
                                                }),
                                                office.address
                                            ]
                                        }),
                                        office?.contact && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                    children: [
                                                        office.contactLabel || "Contact Us",
                                                        " : "
                                                    ]
                                                }),
                                                office.contact
                                            ]
                                        })
                                    ]
                                })
                            });
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: `d-none d-sm-block ${(_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_6___default().tagline)}`,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                    xl: 6,
                                    lg: 6,
                                    md: 6,
                                    sm: 12,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h6", {
                                        children: data?.fulfillText
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                    xl: 6,
                                    lg: 6,
                                    md: 6,
                                    sm: 12,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_6___default().bgkc),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                className: `${(_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_6___default().foterReg)} ${jotformId ? `${(0,_utils_helpers__WEBPACK_IMPORTED_MODULE_5__/* .isFrappeOrJotFormClass */ .gd)(jotformId)}` : ""}`,
                                                onClick: ()=>{
                                                    !jotformId && generateLink(externalLink);
                                                },
                                                children: data.button?.label || "Register Now"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                                                dangerouslySetInnerHTML: {
                                                    __html: `window.lintrk('track', { conversion_id: 6870956 });`
                                                }
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (EduFairFooterCommon);


/***/ }),

/***/ 91071:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(21174);
/* harmony import */ var _styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(34051);
/* harmony import */ var react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(31555);
/* harmony import */ var _CustomImage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45992);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46066);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98322);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98745);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(78182);
/* harmony import */ var react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72679);
/* harmony import */ var react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59830);
/* harmony import */ var _LazyMedia__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(37462);














const EduFairStudentTestimonials = ({ data  })=>{
    const sliderRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const settings = {
        dotsClass: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_9___default().sliderDots),
        dots: false,
        arrows: false,
        slidesToShow: 3,
        slidesToScroll: 3,
        initialSlide: 0,
        autoplay: true,
        speed: 500,
        infinite: true,
        autoplaySpeed: 5000,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: true,
                    dots: false,
                    arrows: false
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2,
                    infinite: true,
                    dots: true,
                    arrows: false
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    infinite: true,
                    dots: true
                }
            }
        ]
    };
    const settingsvedio = {
        dotsClass: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_9___default().sliderDots),
        dots: true,
        infinite: true,
        speed: _utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .sliderSpeed.mobileSpeed */ .Y$.mobileSpeed,
        autoplaySpeed: _utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .sliderSpeed.mobileAutoplaySpeed */ .Y$.mobileAutoplaySpeed,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true
    };
    const settingDesktopVideo = {
        dotsClass: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_9___default().sliderDots),
        dots: true,
        infinite: true,
        speed: _utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .sliderSpeed.desktopSpeed */ .Y$.desktopSpeed,
        autoplaySpeed: _utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .sliderSpeed.desktopAutoplaySpeed */ .Y$.desktopAutoplaySpeed,
        slidesToShow: 2,
        slidesToScroll: 2,
        arrows: false,
        autoplay: true
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            id: "student-testimoney",
            className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_9___default().studentTesti),
            style: {
                background: data?.sectionBgColor || "#EEF2FB"
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_9___default().testimonials),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_9___default().heading),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    children: data?.sectionTitle
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_9___default().studentVedio),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "d-none d-sm-block",
                                    children: data?.videoUrls?.length > 2 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        ...settingDesktopVideo,
                                        children: data?.videoUrls.map((videoUrl)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_9___default().studVedio),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_6__.LazyLoadComponent, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LazyMedia__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                        width: "100%",
                                                        src: videoUrl?.imageUrl,
                                                        title: "YouTube video player",
                                                        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                                                        iframeClassName: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_9___default().ipadiframe),
                                                        tag: "iframe"
                                                    })
                                                })
                                            }))
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                        className: "justify-content-center",
                                        children: data?.videoUrls?.length > 0 && data?.videoUrls.map((videoUrl)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                                lg: 6,
                                                xl: 6,
                                                md: 6,
                                                sm: 12,
                                                className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_9___default().col),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_9___default().studVedio),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_6__.LazyLoadComponent, {
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LazyMedia__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                            width: "100%",
                                                            src: videoUrl?.imageUrl,
                                                            title: "YouTube video player",
                                                            allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                                                            iframeClassName: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_9___default().ipadiframe),
                                                            tag: "iframe"
                                                        })
                                                    })
                                                })
                                            }))
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "d-block d-sm-none",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_9___default().vedioStuSlidr),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                            ...settingsvedio,
                                            className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_9___default().slider),
                                            children: data?.videoUrls?.length > 0 && data?.videoUrls.map((videoUrl)=>{
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_9___default().studVedio),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_6__.LazyLoadComponent, {
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LazyMedia__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                            width: "100%",
                                                            height: "200",
                                                            src: videoUrl?.imageUrl,
                                                            title: "YouTube video player",
                                                            allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                        })
                                                    })
                                                });
                                            })
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_9___default().stuSchSlider),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        ...settings,
                                        ref: sliderRef,
                                        className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_9___default().slider),
                                        children: data?.testimonials?.length > 0 && data?.testimonials.map((td)=>{
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_9___default().sliderCardDiv),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                                    className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_9___default().cardCust),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_9___default().studeImgDiv),
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_9___default().stImg),
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                                        src: td?.studentImageUrl || "/",
                                                                        width: 160,
                                                                        height: 160,
                                                                        className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_9___default().cardImg),
                                                                        alt: "Arusha-Kelkar.png"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_9___default().stuName),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                                            children: td?.studentName
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                            children: td?.studentUniversity
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_13__/* ["default"].Body */ .Z.Body, {
                                                            className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_9___default().cardBody),
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_9___default().studenSay),
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                                                            width: "33",
                                                                            height: "22",
                                                                            viewBox: "0 0 33 22",
                                                                            fill: "none",
                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                                                    fillRule: "evenodd",
                                                                                    clipRule: "evenodd",
                                                                                    d: "M0.0267741 14.2441C0.0232465 14.3384 0.0214669 14.4331 0.0214669 14.5283C0.0214665 18.6548 3.36666 22 7.49316 22C11.6197 22 14.9648 18.6548 14.9648 14.5283C14.9648 10.4018 11.6197 7.05662 7.49316 7.05662C6.73028 7.05662 5.99411 7.17095 5.30084 7.38341C6.8185 4.06918 11.3775 1.11242 13.5805 1.32304e-05C2.06855 2.26919 -0.255979 10.4465 0.0207498 14.2516L0.0267741 14.2441Z",
                                                                                    fill: "#226CF5"
                                                                                }),
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                                                    fillRule: "evenodd",
                                                                                    clipRule: "evenodd",
                                                                                    d: "M18.0492 14.2439C18.0457 14.3382 18.0439 14.4331 18.0439 14.5283C18.0439 18.6548 21.3891 22 25.5156 22C29.6421 22 32.9873 18.6548 32.9873 14.5283C32.9873 10.4018 29.6421 7.05662 25.5156 7.05662C24.7527 7.05662 24.0164 7.17097 23.3231 7.38347C24.8408 4.06924 29.3998 1.11247 31.6028 6.47288e-05C20.0908 2.26924 17.7663 10.4466 18.043 14.2516L18.0492 14.2439Z",
                                                                                    fill: "#226CF5"
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_9___default().stupara),
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                            children: td?.message
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            });
                                        })
                                    }),
                                    data?.testimonials?.length > 3 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_9___default().arrowsClass),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_9___default().btcircle),
                                                onClick: ()=>sliderRef?.current?.slickPrev(),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                    src: "/new-images/left-arrow.svg",
                                                    height: 17,
                                                    width: 10,
                                                    alt: "left-arrow"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_9___default().btcircle),
                                                onClick: ()=>sliderRef?.current?.slickNext(),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                    src: "/new-images/right-arrow.svg",
                                                    height: 17,
                                                    width: 10,
                                                    alt: "right-arrow"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (EduFairStudentTestimonials);


/***/ }),

/***/ 98196:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);


const useZipmeLink = ()=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    const { 0: zipmeLink , 1: setZipmeLink  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("");
    const generateLink = (externalLink)=>{
        if (!externalLink) {
            console.warn("No external link provided!");
            return;
        }
        if (!router.isReady) return;
        const queryString = router.asPath.split("?")[1];
        const newLink = queryString ? `${externalLink}?${queryString}` : externalLink;
        setZipmeLink(newLink);
        window.open(newLink, "_blank");
    };
    return {
        zipmeLink,
        generateLink
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useZipmeLink);


/***/ }),

/***/ 79373:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"error":"Error_error__5J6pK","clip":"Error_clip__SVATU","shadow":"Error_shadow__FSdAk","main":"Error_main__RrWpw","digit":"Error_digit__HcJVc","btndiv":"Error_btndiv__gV_0s","btnPrimary":"Error_btnPrimary__RVY52","msg":"Error_msg__ksdYX","triangle":"Error_triangle__qa4xL","containerError404":"Error_containerError404__DhF_F"};

/***/ }),

/***/ 21174:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mainSectionBg":"educationFair_mainSectionBg__f9xFn","partUni":"educationFair_partUni__waZut","heading":"educationFair_heading__9gEQ7","studentTesti":"educationFair_studentTesti__x6F_4","testimonials":"educationFair_testimonials__lqDsw","kcByNumber":"educationFair_kcByNumber__ZkmbH","number":"educationFair_number__HkKJe","choosekc":"educationFair_choosekc__Vwr9m","whykc":"educationFair_whykc__5vSGW","topScholarship":"educationFair_topScholarship__5qvn_","ScholarshipStudent":"educationFair_ScholarshipStudent__uItOq","studentSpecialOffer":"educationFair_studentSpecialOffer__6LOlm","whoWillYouMeet":"educationFair_whoWillYouMeet__ywIRz","banner":"educationFair_banner__o09Lk","sponserdSecdesk":"educationFair_sponserdSecdesk__TWesk","nav":"educationFair_nav__IwAIT","navLogo":"educationFair_navLogo__a2RbS","maincontent":"educationFair_maincontent__Lf9vo","fairdetails":"educationFair_fairdetails__lQnhO","events":"educationFair_events__QXT_l","time":"educationFair_time__DGHYd","location":"educationFair_location__q6eeA","icon":"educationFair_icon__O_stz","btnReg":"educationFair_btnReg__F_B_u","regBtn":"educationFair_regBtn__eAl7i","bannerStudDiv":"educationFair_bannerStudDiv__oweS7","bg":"educationFair_bg__mB7Z3","whyattend":"educationFair_whyattend__9DHww","maindiv":"educationFair_maindiv__e3jYl","contentDiv":"educationFair_contentDiv__KZqDx","mainBox":"educationFair_mainBox__U0NP0","box":"educationFair_box__8d_P2","img":"educationFair_img__MDtHp","whoyoumeetslider":"educationFair_whoyoumeetslider__iq4CA","card":"educationFair_card__QO3LX","cardImgDiv":"educationFair_cardImgDiv__YIgbH","cardImg":"educationFair_cardImg__twGj3","cardBody":"educationFair_cardBody__QSbke","sliderDots":"educationFair_sliderDots__pxVyJ","OffersContent":"educationFair_OffersContent__QpR_A","ulItem":"educationFair_ulItem__all6_","liItem":"educationFair_liItem__R6rLJ","anchor":"educationFair_anchor__hv76g","schStImg":"educationFair_schStImg__nbwjP","schStd":"educationFair_schStd__X6DBn","SchContent":"educationFair_SchContent__0egHz","studentFooter":"educationFair_studentFooter___maMm","session":"educationFair_session__Y8wel","stuSchSlider":"educationFair_stuSchSlider__ZQ6Kd","sliderCardDiv":"educationFair_sliderCardDiv__5Nvnd","cardCust":"educationFair_cardCust__nGxCS","studeImgDiv":"educationFair_studeImgDiv__7z4sw","stuName":"educationFair_stuName__PBR4S","StdDetail":"educationFair_StdDetail__CyjJi","arrowsClasses":"educationFair_arrowsClasses__QxU4_","btcircle":"educationFair_btcircle__gKp8O","col":"educationFair_col__4EaZs","studVedio":"educationFair_studVedio__nlAM_","studenSay":"educationFair_studenSay__kp1ip","stupara":"educationFair_stupara__aRQBw","stImg":"educationFair_stImg__WravK","clickTabsCountry":"educationFair_clickTabsCountry__CV_tU","flagsapn":"educationFair_flagsapn__k2m7j","countryFlag":"educationFair_countryFlag__CaX7T","countryBox":"educationFair_countryBox___lVYR","flag":"educationFair_flag__JcPo4","ClickshowUniLogo":"educationFair_ClickshowUniLogo__zTBns","uniLogodiv":"educationFair_uniLogodiv__ahGRq","uniImg":"educationFair_uniImg__2yFZZ","UniFlagImg":"educationFair_UniFlagImg__vm3pF","footerbg":"educationFair_footerbg__GwKRk","footer":"educationFair_footer__566jv","content":"educationFair_content__c6N9c","footerLogo":"educationFair_footerLogo__sR7MV","address":"educationFair_address__azyE2","tagline":"educationFair_tagline__h4hlS","foterReg":"educationFair_foterReg__27mpH","ngpWhyAttend":"educationFair_ngpWhyAttend__apAKJ","activeClass":"educationFair_activeClass__bxqcH","arrowsClass":"educationFair_arrowsClass__mfj0d"};

/***/ })

}]);